export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/chatbots.044df52.svg";